import { useSelector } from 'react-redux';

import Alert, { AlertButtons } from '@r1-frontend/ui-react/components/Alert';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';

import { PassportUpdateButton } from '~/src/features/lk/PassportUpdate/containers/PassportUpdateButton';
import { TState } from '~/src/store';

/**
 * Алерт о необходимости актуализации паспортных данных
 */
export const PassportUpdateAlert = () => {
    const isDataActual = useSelector((state: TState) => state.passportUpdate.isDataActual);

    if (isDataActual) {
        return null;
    }

    return (
        <Alert type={'error'}>
            <Paragraph4>
                Пожалуйста, обновите свои данные через Госуслуги. В&nbsp;соответствии с&nbsp;законом 115-ФЗ мы&nbsp;должны следить, чтобы они оставались актуальными.
            </Paragraph4>
            <AlertButtons>
                <PassportUpdateButton/>
            </AlertButtons>
        </Alert>
    );
};
